/*
 * Public API Surface of sdk-tabs
 */

export { SDKTabsModule } from './lib/sdk-tabs.module';
export { SDKTabsComponent, SDKTab } from './lib/sdk-tabs.component';
